export const EngagementDashboardsRoutes = {
    "/compaas-dashboard": {
        "name": "appLayout.harriSH.dashboards.compaas",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            }
        ]
    },
    "/employee-voice?from_date&to_date&redirect&tree_id": {
        "name": "appLayout.harriSH.dashboards.sentiment-engagement",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
        ],
    },
    "/tl-compaas-dashboard": {
        "name": "appLayout.schedule.tl-compaas-dashboard",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
        ],
    },

    "/gp-main-dashboard?date": {
        "name": "appLayout.harriSH.dashboards.main-gp",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/brand-glossary/brand-glossary.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/save-views/save-views.module.js");
                }
            },
        ],
    },
    "/risk-dashboard?from_date&to_date&tree_id": {
        "name": "appLayout.harriSH.dashboards.risk",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
        ],
    },
    "/parent-main-dashboard?date": {
        "name": "appLayout.harriSH.dashboards.main-parent",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/brand-glossary/brand-glossary.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/save-views/save-views.module.js");
                }
            },
        ],
    },
};
